import { orderBy as e } from "es-toolkit/compat";
import { orderBy as t } from "natural-orderby";
//#region src/utils/SortUtils.ts
var n = {
	ASCENDING: "asc",
	DESCENDING: "desc"
}, r = (e, t) => typeof e[t] == "string" ? e[t].toLowerCase() : e[t], i = (t, i, a = n.ASCENDING, o) => o ? e(t, [i], a) : e(t, (e) => r(e, i), a), a = (e, i, a = n.ASCENDING, o) => o ? t(e, i, [a]) : t(e, (e) => r(e, i), a);
//#endregion
export { n as SortDirection, n as default, a as naturalSortByProperty, i as sortByProperty };

//# sourceMappingURL=SortUtils.js.map